import { z } from 'zod';

export const CartModifierSchema = z.object({
    modifierId: z.number().int().positive(),
    modifierGuid: z.string().optional(),
    name: z.string().min(1).max(255),
    priceDelta: z.number().min(0),
    quantity: z.number().int().min(1).default(1)
});

export const CartModifierDataSchema = z.object({
    modifierId: z.number().int().positive(),
    modifierGuid: z.string().optional(),
    name: z.string().min(1).max(255),
    priceDelta: z.number().min(0).default(0),
    quantity: z.number().int().min(1).default(1)
});

export type CartModifierSchemaType = z.infer<typeof CartModifierSchema>;
export type CartModifierDataSchemaType = z.infer<typeof CartModifierDataSchema>;
